import React from "react";
import {
  Text,
  Tooltip,
} from "@chakra-ui/react";


const CustomizeAITextHeaders = ({ input = "", description = "", text }) => {
  return (
    <Tooltip
      placement="top-start"
      label={description}
    >
      {text? text : <Text fontSize="sm" fontWeight="bold" mt={2} ml={1}> {input} </Text> }
    </Tooltip>
  )
};

export default CustomizeAITextHeaders;
